export default __webpack_public_path__ + "static/media/flea-beetle.3df8f0e3.jpg";